'use client';

import { CSSProperties } from 'react';

type CustomIconProps = {
    /** Sanitizovaný inline SVG markup (z config.icons.customIcons). */
    svg: string;
    size?: number;
    className?: string;
    style?: CSSProperties;
};

/**
 * Vyrenderuje uživatelem nahranou SVG ikonu inline. Markup je sanitizován
 * při uložení v editoru (sanitize-svg.ts), runtime mu důvěřuje.
 */
export const CustomIcon = ({ svg, size = 24, className, style }: CustomIconProps) => {
    return (
        <span
            data-custom-icon=""
            className={className}
            style={{
                display: 'inline-flex',
                width: size,
                height: size,
                flexShrink: 0,
                lineHeight: 0,
                ...style,
            }}
            dangerouslySetInnerHTML={{ __html: svg }}
        />
    );
};
